import { postRequest } from '@/core';
import { transporterOrders } from '@/requests';

export default async function updateTransporterOrderRequest(transporterOrderId, data) {
	let url = transporterOrders.getByIdPath(transporterOrderId);
	let response = await postRequest(url, {}, data);
	return response;
}
